import React from 'react';
import { Card, Row, Col, Empty } from 'antd';
import { SendOutlined, TrophyOutlined } from '@ant-design/icons';
import { AppStats, ConversionStats } from 'types/push.types';
import { RateRow } from './RateRow';
import styles from '../../pages/Statistics/statistics.module.css';

type PushStats = NonNullable<AppStats['push_stats']>;

interface DashboardOverviewProps {
  pushStats?: PushStats;
  conversions?: ConversionStats;
}

const rate = (part: number, whole: number) => (whole > 0 ? (part / whole) * 100 : 0);

export const DashboardOverview: React.FC<DashboardOverviewProps> = ({ pushStats, conversions }) => (
  <Row gutter={[12, 12]}>
    <Col xs={24} lg={12}>
      <Card
        title={
          <span className={styles.chartTitle}>
            <div className={styles.chartTitleIcon}>
              <SendOutlined />
            </div>
            Доставка и клики
          </span>
        }
        className={styles.statsCard}
      >
        {pushStats ? (
          <div className={styles.rateList}>
            <RateRow
              label="Доставляемость"
              value={rate(pushStats.total_delivered, pushStats.total_sent)}
              caption={`${pushStats.total_delivered.toLocaleString('ru-RU')} из ${pushStats.total_sent.toLocaleString('ru-RU')} отправленных`}
            />
            <RateRow
              label="Кликабельность"
              value={rate(pushStats.total_clicked, pushStats.total_sent)}
              caption={`${pushStats.total_clicked.toLocaleString('ru-RU')} кликов`}
            />
          </div>
        ) : (
          <Empty description="Нет данных" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </Card>
    </Col>

    <Col xs={24} lg={12}>
      <Card
        title={
          <span className={styles.chartTitle}>
            <div className={styles.chartTitleIcon}>
              <TrophyOutlined />
            </div>
            Атрибуция конверсий
          </span>
        }
        className={styles.statsCard}
      >
        {conversions ? (
          <div className={styles.rateList}>
            <RateRow
              label="Регистрации"
              value={conversions.registration_rate ?? 0}
              caption={`${conversions.registrations_from_push.toLocaleString('ru-RU')} из ${conversions.registrations_total.toLocaleString('ru-RU')} пришли из push`}
            />
            <RateRow
              label="Депозиты"
              value={conversions.deposit_rate ?? 0}
              caption={`${conversions.deposits_from_push.toLocaleString('ru-RU')} из ${conversions.deposits_total.toLocaleString('ru-RU')} пришли из push`}
            />
          </div>
        ) : (
          <Empty description="Нет данных" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </Card>
    </Col>
  </Row>
);